import Drawer from '@material-ui/core/Drawer';
import * as React from 'react';
import { connect } from 'react-redux';
import { acknowledgeNotification, refreshNotifications, clearNotifications } from '../../actions/utility-actions';
import { LoadingInlinePanel } from '../../components/loading/LoadingInline';
import { UserNotification } from '../../models/utilities/user-notification';
import { IApplicationState } from '../../store/IApplicationState';
import { toLongDateTimeNoSeconds } from '../../utils/date-utils';
import './NotificationDrawer.scss';

// #region Component State

const initialState = {
    isOpen: false,
    isConnected: false
};

type State = Readonly<typeof initialState>;

// #endregion

// #region Component Props

interface IProps {
    notifications: UserNotification[];
    hasConnectivity: boolean;
    acknowledgeNotification: any;
    checkForNotifications: any;
    clearNotifications: any;
}

// #endregion

class NotificationDrawerComponent extends React.Component<IProps, State> {

    public state: State = initialState;

    public toggleDrawer = (open : boolean) => () => {
        this.setState({
            isOpen: open,
            isConnected: false
        });
    }

    public acknowledgeNotification = (notificationId : string) => {
        this.props.acknowledgeNotification(notificationId);
    }

    public checkForNotifications = () => {
        this.props.checkForNotifications();
    }

    public clearNotifications = () => {
        this.props.clearNotifications();
    }

    public render() {

        return (
            <div>
                <button 
                    className={"btn-icon notification-drawer-button " + (!this.props.hasConnectivity ? 'is-offline' : '') }
                    onClick={this.toggleDrawer(true)}>
                        <i className="la la-bell" />
                        {
                            this.props.notifications.length > 0
                                ? <div className="badge-count">{ this.props.notifications.length }</div>
                                : null
                        }
                </button>
                <Drawer anchor="right" open={this.state.isOpen} onClose={this.toggleDrawer(false)}>
                    <div className="notification-drawer">
                        <h3>
                            Notifications
                            <button 
                                onClick={ this.checkForNotifications }
                                className="btn-clear drawer-refresh">
                                    <i className="la la-refresh"/>
                            </button>

                            <button
                                onClick={this.clearNotifications}
                                className="btn-clear drawer-refresh">
                                <i className="la la-trash" />
                            </button>
                        </h3>
                        {
                            !this.props.hasConnectivity
                                ? <p className="not-connceted-note">No Realtime Connection</p>
                                : null
                        }
       
                        {
                            this.props.notifications.length > 0 ?
                            this.props.notifications.map((itm : UserNotification, idx : number) => 
                                <div className="notification-drawer-item" key={`notification-${idx}`}>
                                    <div>
                                        <p className="notification-title" title={ `TYPE: ${ itm.topic }` } >{ itm.title }</p>
                                        <p className="notification-desc">{ itm.description }</p>
                                        <p className="notification-date">{ toLongDateTimeNoSeconds(itm.timestamp) }</p>       
                                    </div>
                                    <div className="notification-ack">
                                        {
                                            itm.isInFlight
                                                ? <LoadingInlinePanel message="" />
                                                : <button 
                                                    onClick={ () => this.acknowledgeNotification(itm.id) }
                                                    className="btn-clear">
                                                    <i className="la la-check-circle"/>
                                                </button>
                                        }                                        
                                    </div>
                                </div>
                            ) : 
                            <div className="notificationdrawer-item">
                                <h3>You are all caught up!</h3>
                            </div>
                        }
                        
                    </div>
                </Drawer>
            </div>
        );
    }

    private clickHandler = (key:string) => {
        switch(key) {
            case 'reload':
                location.reload(true);
                break;
        }
    }
}

const mapStateToProps = (state: IApplicationState) => {
    return {
        notifications: state.utility.notifications,
        hasConnectivity: state.utility.signalRConnected
    };
};

const mapDispatchToProps = (dispatch: any) => {
    return {
        acknowledgeNotification: (notificationId: string) => dispatch(acknowledgeNotification(notificationId)),
        checkForNotifications: () => dispatch(refreshNotifications()),
        clearNotifications: () => dispatch(clearNotifications())
    };
};

const NotificationDrawer = connect(
    mapStateToProps,
    mapDispatchToProps
)(NotificationDrawerComponent);

export { NotificationDrawer };
